import {
    FETCH_TOTAL_FEEDBACK_PROVIDERS_START,
    FETCH_TOTAL_FEEDBACK_PROVIDERS_SUCCESS,
    FETCH_TOTAL_FEEDBACK_PROVIDERS_FAIL,

} from "../../../constants";
import {
    FETCH_TOTAL_FEEDBACK_URL,
} from "../../../../../config/constants";
import { ApiBase } from "../../../../utils/apiBase";
import { withType } from "../../../../utils/actionOperations";
import { getProjectIdAndOrgId } from '../../../../utils/apiUtils';
import { SETTINGS_PAGE_SECTION } from "../../../../../config/tabConstants";

export const getTotalFeedbackProviders = (payload, cb) => {
    const apiBaseInstance = new ApiBase().instance;
    return (dispatch) => {
        dispatch(
            withType(FETCH_TOTAL_FEEDBACK_PROVIDERS_START, { ...payload })
        );
        return apiBaseInstance
            .post(FETCH_TOTAL_FEEDBACK_URL, {
                benchmarkFilters: payload, ...getProjectIdAndOrgId(payload),currentTab: SETTINGS_PAGE_SECTION.SETTINGS_SUB_TABS.ADMINISTRATOR
            })
            .then((res) => {
                dispatch(
                    withType(FETCH_TOTAL_FEEDBACK_PROVIDERS_SUCCESS, {
                        data: res.data,
                        payload: payload
                    })
                );
                cb && cb()
            })
            .catch((err) => {
                dispatch(withType(FETCH_TOTAL_FEEDBACK_PROVIDERS_FAIL, { ...err, ...payload }));
                cb && cb()
            });
    };
};

